import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gifs/Aguarde.gif'


const _withScopeId = n => (_pushScopeId("data-v-363f906f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-page" }
const _hoisted_2 = { class: "inline-block d-flex mb-0 w-100 justify-content-center" }
const _hoisted_3 = { class: "form-label text-center fs-1 nav-link" }
const _hoisted_4 = { class: "w-100 d-flex justify-content-start mb-2" }
const _hoisted_5 = {
  class: "table mb-0 table-striped",
  id: "tabela"
}
const _hoisted_6 = { class: "borda mt-0" }
const _hoisted_7 = ["id"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-center cabecalho linha btn-ocultar-alterar col-md-1 col-sm-1" }, " Verificar", -1))
const _hoisted_9 = ["id", "onClick"]
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = {
  key: 1,
  class: ""
}
const _hoisted_12 = {
  key: 2,
  class: ""
}
const _hoisted_13 = { class: "py-0 btn-ocultar-alterar col-md-1 col-sm-1" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "imagem" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "imagemTamanho",
  src: _imports_0,
  alt: "",
  srcset: "",
  width: "50"
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

import { onMounted, reactive } from 'vue';
import ModalPesqDorape from './ModalPesqDorape.vue';
import { TipoMensagem } from '@/consts/consts';
import mensagem from '@/hooks/mensagem';
import services from '@/services';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'Padrao',
  props: ["titulo", "linhas", "colunas", "dados", "url", "linhasAux",
    "colunasAux", 'tabela', 'campoPorId', 'join', 'tabelasJoin',
    'camposJoin', 'sqlJoin', 'distinct', 'where'],
  emits: ["abrirModal"],
  setup(__props, { emit }) {

const props = __props;




const msg = mensagem();
const state = reactive({
    dados: [] as any,

    objetoFilho: Object() as any,
    objetoPesquisa: Object() as any,

    ativarPesquisa: Boolean(),
    carregando: Boolean(),
    telaPequena: Boolean(),

    labelSelecionadoPesquisa: String(),
    campoSelecionadoPesquisa: String(),
    alturaModalPesq: Number(),

});

async function buscarDados() {
    if (window.innerWidth <= 1023) {
        pesquisarDados();
    } else {
        let hql = `SELECT `;
        if (props.distinct)
            hql += "distinct";

        hql += ` t.Id, t.Nome from ${props.url} t`;
        if (props.tabelasJoin) {
            hql += ` RIGHT JOIN ${props.tabelasJoin} ${props.tabelasJoin[0]}${props.tabelasJoin[1]}${props.tabelasJoin[2]} ON T.ID = ${props.tabelasJoin[0]}${props.tabelasJoin[1]}${props.tabelasJoin[2]}.ID_PACIENTE `;
        }
        const { data, erros } = await services.relatorio.ListarSql(hql);
        if (!erros) {
            for (let i = 0; i < 2000; i++) {
                let obj = Object() as any;
                obj['id'] = data[i][0];
                obj['nome'] = data[i][1];
                state.dados.push(obj);
            }
        } else {
            msg.InserirMensagem("Erro", `Não foi possivel obter dados de ${props.url}. Tente Novamente mais tarde`, TipoMensagem.Error);
        }
    }
}

async function mostrar(pAtualizando: boolean, pObj: any, auxiliar?: boolean | null) {
    (auxiliar) ? emit('abrirModal', pObj) : "";
}

async function mostrarTelaMenor(pAtualizando: boolean, pObj: any, auxiliar?: boolean | null) {
    if (window.innerWidth <= 1023) {
        (auxiliar) ? emit('abrirModal', pObj) : '';
    }
}

function pesquisarDados(pParam?: string, pIndice?: number) {
    // state.objetoPesquisa = state.dados[0];
    state.ativarPesquisa = true;
    if (pIndice != null) {
        if (props.linhas.includes("descricao")) {
            state.campoSelecionadoPesquisa = 'descricao';
            state.labelSelecionadoPesquisa = props.colunas[pIndice];
            return;
        }
        if (props.linhas.includes("nome")) {
            state.campoSelecionadoPesquisa = 'nome';
            state.labelSelecionadoPesquisa = props.colunas[pIndice];
            return;
        }
        state.labelSelecionadoPesquisa = "";
        state.campoSelecionadoPesquisa = "";
    }
}

async function modalPesqResult(result: string, pObj: any) {
    state.ativarPesquisa = false;
    (result === "ok") ? await mostrar(true, pObj, true) : '';
    // let i = 0;
    // let teste = setInterval(() => {
    //     i++;
    //     document.querySelector("html")?.classList.remove("overflow-hidden");
    //     if (i == 10) {
    //         clearInterval(teste);
    //     }
    // }, 100);
}

function encontrarColuna(pLinha: string, pIndice: number, pIndiceDado: number) {
    state.campoSelecionadoPesquisa = pLinha;
    state.labelSelecionadoPesquisa = props.colunas[pIndice];
    //@ts-expect-error: un 
    document.querySelector(`#inp${pIndiceDado}`)?.focus();
    document.querySelector(`#inp${pIndiceDado}`)?.addEventListener("keyup", (ev: any) => {
        ev = ev || window.event;
        let key = ev?.which || ev?.keyCode;
        let function2 = 113;
        (function2 === key) ? pesquisarDados("") : "";
    });
}

onMounted(() => {
    buscarDados();
    setInterval(() => {
        window.innerWidth <= 1400 ?
            (state.telaPequena = true, state.alturaModalPesq = 350)
            :
            (state.telaPequena = false, state.alturaModalPesq = 500);
    }, 100);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.titulo), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-secondary ms-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (pesquisarDados('', 1)))
        }, "Pesquisar")
      ]),
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.colunas, (c, i) => {
              return (_openBlock(), _createElementBlock("td", {
                key: c,
                id: __props.linhas[i],
                class: _normalizeClass(["linha cabecalho pointer", { 'col-1': c == 'Código' }])
              }, _toDisplayString(c), 11, _hoisted_7))
            }), 128)),
            _hoisted_8
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.dados, (d, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: d }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.linhas, (l, i) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: _normalizeClass(["linha", { 'texto-inativo': d.ativo === false }]),
                  id: `${l}${index}`,
                  key: i,
                  onClick: ($event: any) => (mostrarTelaMenor(true, d, true), encontrarColuna(l, i, index))
                }, [
                  _withDirectives(_createElementVNode("span", { class: "" }, _toDisplayString(_unref(moment)(d[l]).format('DD/MM/YYYY')), 513), [
                    [_vShow, typeof d[l] === 'string' && d[l].includes('T00:00:00')]
                  ]),
                  (typeof d[l] === 'object' && d[l]?.descricao)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(d[l]?.descricao), 1))
                    : (typeof d[l] === 'object' && d[l]?.nome)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(d[l]?.nome), 1))
                      : ((typeof d[l] === 'object'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " NÃO INFORMADO "))
                        : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("span", { class: "" }, _toDisplayString(d[l]), 513), [
                    [_vShow, (typeof d[l] !== 'string' || !d[l].includes('T00:00:00'))
                            && !d[l]?.descricao && !d[l]?.nome
                            ]
                  ])
                ], 10, _hoisted_9))
              }), 128)),
              _createElementVNode("td", _hoisted_13, [
                _createElementVNode("button", {
                  class: "btn btn-full btn-info",
                  onClick: ($event: any) => (mostrar(true, d, true))
                }, "Verificar", 8, _hoisted_14)
              ]),
              _createElementVNode("input", {
                id: `inp${index}`,
                type: "text",
                class: "teste btn border-none"
              }, null, 8, _hoisted_15)
            ]))
          }), 128))
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_16, _hoisted_18, 512), [
      [_vShow, state.carregando == true]
    ]),
    (state.ativarPesquisa)
      ? (_openBlock(), _createBlock(ModalPesqDorape, {
          key: 0,
          id: 'pesq' + __props.url,
          title: __props.url,
          tabela: __props.tabela,
          hqlIdCliente: "t.IdCliente = :IdCliente and",
          SQL: "true",
          tabelaPorId: __props.url,
          listar: "/listar",
          campoPorId: __props.campoPorId,
          nome: "Nome",
          codigo: "Id",
          height: `${state.alturaModalPesq}px`,
          width: "90%",
          visiblePesq: state.ativarPesquisa,
          data: _ctx.$props.dados,
          onModalResult: modalPesqResult,
          colunas: __props.colunas,
          linhas: __props.linhas,
          pesquisaTabela: true,
          campoSelecionado: state.campoSelecionadoPesquisa,
          labelCampoSelecionada: state.labelSelecionadoPesquisa,
          favorito: false,
          cadastroPadrao: true,
          join: __props.join,
          tabelasJoin: __props.tabelasJoin,
          camposJoin: __props.camposJoin,
          sqlJoin: __props.sqlJoin,
          distinct: __props.distinct
        }, {
          header: _withCtx(() => [
            _renderSlot(_ctx.$slots, "icone")
          ]),
          _: 3
        }, 8, ["id", "title", "tabela", "tabelaPorId", "campoPorId", "height", "visiblePesq", "data", "colunas", "linhas", "campoSelecionado", "labelCampoSelecionada", "join", "tabelasJoin", "camposJoin", "sqlJoin", "distinct"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})